<template>
  <div
    v-if="readyToTeleport"
    class="relative z-30 w-full"
  >
    <Teleport to="#formNavigationButtons">
      <div
        class="w-full"
        :data-component-identifier="componentIdentifier"
      >
        <div
          v-if="buttonsToDisplay === 'report-error'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-yellow-50 px-6 pb-8 pt-6 md:flex md:rounded-md md:border-2 md:py-2 md:pl-4 md:pr-2 md:shadow-yellow"
        >
          <div
            class="mb-2 flex justify-between md:mb-0 md:w-2/3 md:self-center md:text-left"
          >
            <p class="align-middle text-dark-gray">
              {{
                formPosition === 0
                  ? 'Is this your company?'
                  : 'Is this information correct?'
              }}
            </p>
            <div class="flex items-center md:hidden">
              <button-main
                class="flex items-center text-yellow-500"
                variant="link"
                @click="openNeedHelpModal"
              >
                Help
                <img
                  class="ml-1 h-3 w-3 sm:ml-3"
                  src="@/assets/yellow-question-mark.svg"
                  alt="question mark"
                />
              </button-main>
            </div>
          </div>
          <span class="md:flex md:w-full md:flex-row-reverse md:gap-x-2">
            <!-- <button-main
                @click="emitNext"
                class="mt-4 md:my-1"
                :disabled="isGlobalButtonDisabled"
                type="submit"
                value="Yes, continue"
                :loadingSpinner="buttonLoading"
              >
              </button-main> -->
            <button-main
              class="mt-4 md:my-1"
              variant="primary"
              type="button"
              :disabled="isGlobalButtonDisabled"
              :loading-spinner="buttonLoading"
              @click="emitNext"
              @enter="onEnterEmitNext"
            >
              Yes, continue
            </button-main>
            <button-main
              variant="secondary"
              class="mt-2 md:my-1"
              @click="openErrorModal"
            >
              No, report an error
            </button-main>
          </span>
        </div>

        <div
          v-else-if="buttonsToDisplay === 'continue-edit'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-yellow-50 px-6 pb-8 pt-6 md:flex md:rounded-md md:border-2 md:py-2 md:pl-4 md:pr-2 md:shadow-yellow"
        >
          <div
            class="mb-2 flex justify-between md:mb-0 md:w-2/3 md:self-center md:text-left"
          >
            <p class="text-dark-gray">Is this information correct?</p>
            <div class="flex items-center md:hidden">
              <button-main
                class="flex items-center text-yellow-500"
                variant="link"
                @click="openNeedHelpModal"
              >
                Help
                <img
                  class="ml-1 mr-1 h-3 w-3 xs:ml-3"
                  src="@/assets/yellow-question-mark.svg"
                  alt="question mark"
                />
              </button-main>
            </div>
          </div>
          <span class="md:flex md:w-full md:flex-row-reverse md:gap-x-2">
            <button-main
              class="mt-4 md:my-1"
              variant="primary"
              type="button"
              :disabled="isGlobalButtonDisabled"
              :loading-spinner="buttonLoading"
              @click="emitNext"
              @enter="onEnterEmitNext"
            >
              Yes, continue
            </button-main>
            <button-main
              variant="secondary"
              class="mt-4 md:my-1"
              @click="emitEdit"
            >
              No, edit
            </button-main>
          </span>
        </div>

        <div
          v-else-if="buttonsToDisplay === 'continue-save'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:p-3 md:shadow-lg"
        >
          <span
            class="flex flex-col md:ml-auto md:w-1/2 md:flex-row-reverse md:gap-x-2"
          >
            <!-- <button-main
                @click="emitNext"
                class="my-2 md:my-0 md:mb-0"
                :disabled="isGlobalButtonDisabled"
                type="submit"
                value="Save & Continue"
                :autoFocus="true"
                :loadingSpinner="buttonLoading"
              >
              </button-main> -->
            <button-main
              class="my-2 md:my-0 md:mb-0"
              variant="primary"
              type="button"
              :auto-focus="true"
              :disabled="isGlobalButtonDisabled"
              :loading-spinner="buttonLoading"
              @click="emitNext"
              @enter="onEnterEmitNext"
            >
              <span class="whitespace-nowrap">Save & Continue</span>
            </button-main>
            <button-main
              variant="secondary"
              @click="emitExitModal"
            >
              Save & Exit
            </button-main>
          </span>
        </div>

        <div
          v-else-if="buttonsToDisplay === 'submit-save'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:p-3 md:shadow-lg"
        >
          <span
            class="flex flex-col md:ml-auto md:w-2/3 md:flex-row-reverse md:gap-x-2"
          >
            <button-main
              class="my-2 whitespace-nowrap text-white md:my-0 md:mb-0"
              :disabled="isGlobalButtonDisabled"
              type="button"
              :auto-focus="false"
              :loading-spinner="buttonLoading"
              @click="emitW8Submit"
            >
              Submit {{ taxFormTitle }}
            </button-main>
            <button-main
              variant="secondary"
              @click="emitExitModal"
            >
              Save & Exit
            </button-main>
          </span>
        </div>

        <div
          v-else-if="buttonsToDisplay === 'finish'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:p-3 md:shadow-lg"
        >
          <div
            class="gap-2 md:ml-auto md:flex md:w-1/2 md:flex-row-reverse md:gap-x-2"
          >
            <!-- <button-main
                :disabled="isGlobalButtonDisabled"
                type="submit"
                value="Agree & Continue"
                :loadingSpinner="finalButtonLoading"
              >
              </button-main> -->
            <button-main
              class="my-2 md:my-0 md:mb-0"
              variant="primary"
              type="button"
              :auto-focus="true"
              :disabled="isGlobalButtonDisabled"
              :loading-spinner="finalButtonLoading"
              @click="emitNext"
              @enter="onEnterEmitNext"
            >
              <span class="whitespace-nowrap">Agree & Continue</span>
            </button-main>
            <button-main
              variant="secondary"
              class="mt-4 md:mt-0"
              @click="emitExitModal"
            >
              Save & Exit
            </button-main>
          </div>
        </div>
        <div
          v-else-if="buttonsToDisplay === 'finish-sign'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:p-3 md:shadow-lg"
        >
          <div
            class="gap-2 md:ml-auto md:flex md:w-1/2 md:flex-row-reverse md:gap-x-2"
          >
            <!-- <button-main
                :disabled="isGlobalButtonDisabled"
                type="submit"
                value="Agree & Continue"
                :loadingSpinner="finalButtonLoading"
              >
              </button-main> -->
            <button-main
              class="my-2 md:my-0 md:mb-0"
              variant="primary"
              type="button"
              :auto-focus="true"
              :disabled="isGlobalButtonDisabled"
              :loading-spinner="finalButtonLoading"
              @click="emitNext"
              @enter="onEnterEmitNext"
            >
              <span class="whitespace-nowrap">Sign & Continue</span>
            </button-main>
            <button-main
              variant="secondary"
              class="mt-4 md:mt-0"
              @click="emitExitModal"
            >
              Save & Exit
            </button-main>
          </div>
        </div>
        <div
          v-else-if="buttonsToDisplay === 'continue-back'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:border-light-gray md:p-3 md:shadow-lg"
        >
          <span
            class="flex flex-col md:ml-auto md:w-1/2 md:flex-row-reverse md:gap-x-2"
          >
            <button-main
              class="my-2 md:my-0 md:mb-0"
              :auto-focus="true"
              @click="emitNext"
              @enter="onEnterEmitNext"
            >
              Continue
            </button-main>
            <button-main
              variant="secondary"
              @click="emitBackFromContinueBack"
            >
              Back
            </button-main>
          </span>
        </div>
        <div
          v-else-if="buttonsToDisplay === 'optional-w9'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:border-light-gray md:p-3 md:shadow-lg"
        >
          <span class="flex flex-col md:ml-auto md:gap-2">
            <button-main
              class="my-2 md:my-0 md:mb-0"
              :auto-focus="true"
              @click="emitBypassW9"
              @enter="onEnterEmitBypassW9"
            >
              <span class="whitespace-nowrap"
                >Continue without completing Form W-9</span
              >
            </button-main>
            <button-main
              variant="secondary"
              class="mb-2 md:my-0 md:mb-0"
              @click="emitCompleteW9Anyway"
            >
              Complete Form W-9 anyway
            </button-main>
            <button-main
              variant="secondary"
              @click="emitViewW8"
            >
              Complete a W-8 form instead
            </button-main>
          </span>
        </div>
        <div
          v-else-if="buttonsToDisplay === 'optional-w8'"
          class="button-container-mobile box-shadow-top z-20 border-t-2 border-yellow-500 bg-white p-6 pb-8 md:rounded-lg md:border md:border-light-gray md:p-3 md:shadow-lg"
        >
          <span class="flex flex-col md:ml-auto md:gap-2">
            <button-main
              class="my-2 md:my-0 md:mb-0"
              :auto-focus="true"
              @click="emitBypassW8"
              @enter="onEnterEmitBypassW8"
            >
              <span class="whitespace-nowrap"
                >Continue without completing a W-8 form</span
              >
            </button-main>
            <button-main
              variant="secondary"
              class="mb-2 md:my-0 md:mb-0"
              @click="emitCompleteW8Anyway"
            >
              Complete a W-8 form anyway
            </button-main>
            <button-main
              variant="secondary"
              @click="emitViewW9"
            >
              Complete Form W-9 instead
            </button-main>
          </span>
        </div>
      </div>
    </Teleport>
    <Teleport to="#backButtonHeaderDesktop">
      <button
        v-if="hideBackButton != true"
        class="flex items-center text-white"
        @click="emitBack"
      >
        <img
          class="mr-2 h-5 w-5"
          src="@/assets/arrow-left-white.svg"
          alt="arrow-left"
        />
        <p>Back</p>
      </button>
    </Teleport>
    <Teleport to="#backButtonHeaderMobile">
      <button
        v-if="hideBackButton != true"
        class="flex items-center text-white"
        @click="emitBack"
      >
        <img
          class="mr-2 h-5 w-5"
          src="@/assets/arrow-left-white.svg"
          alt="arrow-left"
        />
        <p>Back</p>
      </button>
    </Teleport>
  </div>
</template>
<script>
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'Form Navigation Buttons',
  components: {
    ButtonMain,
  },
  props: {
    buttonsToDisplay: {
      type: String,
      required: true,
    },
    isButtonDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    enabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    finalButtonLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    taxFormTitle: {
      type: String,
      required: false,
      default: 'Tax Form',
    },
    componentIdentifier: {
      type: String,
      required: false,
      default: '',
    },
    hideBackButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    useInternalButtonDisabledLogic: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  emits: [
    'next',
    'back',
    'back-from-continue-back',
    'exit-modal',
    'edit',
    'help',
    'w8-submit',
    'bypass-w9',
    'complete-w9-anyway',
    'view-w8',
    'bypass-w8',
    'complete-w8-anyway',
    'view-w9',
  ],
  data() {
    return {
      buttonLoading: false,
    };
  },
  computed: {
    readyToTeleport() {
      return this.$store.state.formRoutes?.onboardingPacketViewIsMounted;
    },
    formPosition() {
      return this.$store.state.formRoutes?.activeStepIndex;
    },
    isGlobalButtonDisabled() {
      if (this.useInternalButtonDisabledLogic) {
        return this.isButtonDisabled;
      }
      return this.$store.state.submitButtonDisabled;
    },
  },
  watch: {
    loading: {
      handler(newVal) {
        if (newVal !== undefined) this.buttonLoading = false;
      },
      immediate: true,
    },
    enabled: {
      handler: function (val) {
        let self = this;
        if (val == true) {
          self.buttonLoading = false;
        }
      },
      // immediate: true,
    },
    '$store.state.questions.section_index': {
      handler: function (newVal, oldVal) {
        let self = this;
        if (newVal != oldVal && self.componentIdentifier == 'Questions') {
          self.$store.commit(
            'addFormDebugMessage',
            this.componentIdentifier +
              ' > FormNavigationButtons: questions.section_index changed in store, setting buttonLoading to false'
          );
          self.buttonLoading = false;
        }
      },
      // immediate: true,
    },
    '$store.state.formRoutes.errorOnNextStepPatch': {
      handler: function (newVal) {
        let self = this;
        if (newVal == true) {
          self.$store.commit('formRoutes/setErrorOnNextStepPatch', false);
          self.buttonLoading = false;
        }
      },
      // immediate: true,
    },
  },
  methods: {
    openNeedHelpModal() {
      this.$store.commit('setShowNeedHelpModal', true);
    },
    openErrorModal() {
      this.$store.commit('setShowErrorModal', true);
    },
    emitNext() {
      this.buttonLoading = true;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier + " > FormNavigationButtons: 'next' emitted"
      );
      this.$emit('next');
    },
    emitBack() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier + " > FormNavigationButtons: 'back' emitted"
      );
      this.$emit('back');
    },
    emitBackFromContinueBack() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'back-from-continue-back' emitted"
      );
      this.$emit('back-from-continue-back');
    },
    emitExitModal() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'exit-modal' emitted"
      );
      this.$emit('exit-modal');
    },
    emitEdit() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier + " > FormNavigationButtons: 'edit' emitted"
      );
      this.$emit('edit');
    },
    emitHelp() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier + " > FormNavigationButtons: 'help' emitted"
      );
      this.$store.commit('setShowNeedHelpModal', true);
      this.$emit('help');
    },
    emitW8Submit() {
      this.buttonLoading = true;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'w8-submit' emitted"
      );
      this.$emit('w8-submit');
      let self = this;
      setTimeout(() => {
        self.buttonLoading = false;
      }, 1000);
    },
    onEnterEmitNext() {
      if (!this.enabled) return;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: Enter key pressed, emitting 'next'"
      );
      this.emitNext();
    },
    emitBypassW9() {
      this.buttonLoading = true;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'bypass-w9' emitted"
      );
      this.$emit('bypass-w9');
    },
    onEnterEmitBypassW9() {
      if (!this.enabled) return;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: Enter key pressed, emitting 'bypass-w9'"
      );
      this.emitBypassW9();
    },
    emitCompleteW9Anyway() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'complete-w9-anyway' emitted"
      );
      this.$emit('complete-w9-anyway');
    },
    emitViewW8() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier + " > FormNavigationButtons: 'view-w8' emitted"
      );
      this.$emit('view-w8');
    },
    emitBypassW8() {
      this.buttonLoading = true;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'bypass-w8' emitted"
      );
      this.$emit('bypass-w8');
    },
    onEnterEmitBypassW8() {
      if (!this.enabled) return;
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: Enter key pressed, emitting 'bypass-w8'"
      );
      this.emitBypassW8();
    },
    emitCompleteW8Anyway() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier +
          " > FormNavigationButtons: 'complete-w8-anyway' emitted"
      );
      this.$emit('complete-w8-anyway');
    },
    emitViewW9() {
      this.$store.commit(
        'addFormDebugMessage',
        this.componentIdentifier + " > FormNavigationButtons: 'view-w9' emitted"
      );
      this.$emit('view-w9');
    },
  },
};
</script>
